import { endsWith, findIndex, flow, get, isEqual, isNil, map, negate, reject, some, filter } from 'lodash/fp'
import { useContext, useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import styled from 'styled-components'

import { analyticsPageViewEvent } from 'analytics/actions'
import {
  fetchSignature,
  hideDialog,
  hideLoading,
  showDialog,
  verifyPolicy,
  comfirmSubmittedPolicy,
  saveAppData,
  setDopaRequestFailedModal,
  submittedPolicy,
  setAppValue,
  resetEDAViewFormOnly,
  unsetEDACheckStatus,
  setConfirmLuckyNumberModal,
  getAIUWStatus,
  requestAIUWwithGetStaus,
} from 'e-submission/apps/actions'
import {
  getCurrentAppStatus,
  getCurrentApp,
  getAppProgress,
  getPages,
  isAllDocumentSigned,
  isCertifyByAgent,
  getCurrentAppId,
  getStateSaleForm,
} from 'e-submission/apps/selectors'
import InsuredInfoCard from 'e-submission/components/Card/InsuredInfoCard'
import FormEngine from 'e-submission/components/FormEngine'
import {
  getInsuredDopaResult,
  getPayerDopaResult,
  getSkippedInsuredEkyc,
  getSkippedPayerEkyc,
  getInsuredDopaRequestFailed,
  getPayerDopaRequestFailed,
  getSelectedLuckyNumber,
  isLuckyNumber,
  getLuckyNumberStatus,
  getInsuredDopaResultResponseDataMessage,
  getPayerDopaResultResponseDataMessage,
  isATPBankWasKTB,
  isATPBankWasBay,
  isAccountChecked,
  havePayer,
  isJuvenileEkyc,
  isForeigner,
  isSelectedF2F,
  isSelectedRemoteSelling,
} from 'e-submission/domain/data-model/form/selectors'
import { when } from 'e-submission/utils'
import { PagesContext, NextButtonContext } from 'quick-quote/containers'
import { getToggles } from 'quick-quote/feature-toggles'
import { updateOptyStageEApp, updateOptyStageKyc } from 'quick-quote/opty/actions'

import FormValidation from './FormValidation'

const AppForm = styled(({ className, pages, sections, match, ...props }) => {
  const setPages = useContext(PagesContext)
  const setNextButton = useContext(NextButtonContext)
  const location = useLocation()
  const pathname = location.pathname
  const prevPathName = useRef()

  const hasCalledReSaveAiUw = useRef(false)
  useEffect(() => {
    setNextButton(props.nextButtonProps)
    setPages(props.navProps)
    if (getToggles().ENABLE_REMOVE_POLICY_NO_GA4) {
      props.dispatchAnalyticsPageViewEvent(location.pathname)
    }
    const isSubmitFormPage = (location.pathname || '').endsWith('/e-submission/form/submit')

    return () => {
      setPages(null)
      setNextButton(null)
    }
  }, [location.pathname])

  useEffect(() => {
    setPages(props.navProps)
    return () => {
      setPages(null)
    }
  }, [JSON.stringify(props.navProps)])

  useEffect(() => {
    setNextButton(props.nextButtonProps)
  }, [props.currentApp])

  useEffect(() => {
    setNextButton(props.nextButtonProps)
    fetchSignature(props)
  }, [props.nextButtonProps.text, props.nextButtonProps.to, props.canGotoNextPage, props.canSign])

  useEffect(() => {
    let pathname = prevPathName.current || location.pathname
    const changePageFromEkyc = (pathname || '').includes('/e-submission/form/ekyc')
    const changePageFrom2Doc = (pathname || '').includes('/e-submission/form/document')
    const changePageOutFromAgent = (pathname || '').includes('/e-submission/form/agent')
    const changePageOutFromInsured = (pathname || '').includes('/e-submission/form/insured')
    const changePageFromInsuredHealth = (pathname || '').includes('/e-submission/form/insured-health')
    const changePageOutFromPayer = (pathname || '').includes('/e-submission/form/owner')
    const changePageToFormEDA = (location.pathname || '').includes('/e-submission/form/submit/eda')
    const changePageToFormDA = (location.pathname || '').includes('/e-submission/form/submit/atp')
    const changePageOutFromEDAForm = (pathname || '').includes('/e-submission/form/submit/eda')
    const changePageToSubmitForm = (location.pathname || '').endsWith('/e-submission/form/submit')

    if (getToggles().ENABLE_REMOVE_POLICY_NO_GA4) {
      props.dispatchAnalyticsPageViewEvent(pathname)
    }
    if (getToggles().ENABLE_OPTIMIZE_SAVING_REQUEST) {
      props.dispatchSavingAppOnPageNav()
    }
    if (
      (changePageOutFromAgent || changePageOutFromInsured || changePageOutFromPayer) &&
      !changePageFromInsuredHealth
    ) {
      props.dispatchUppdateOptyStageEApp()
    }

    if (changePageFromEkyc || changePageFrom2Doc) {
      props.dispatchUpdateOptyStageKyc()
    }

    if (getToggles().ENABLE_EDA && (changePageToFormEDA || changePageToFormDA)) {
      let typeDA = 'FORM'
      if (changePageToFormEDA) {
        typeDA = 'ONLINE'
        if (!props.isSelectedEdaBank) props.setDefaultBankForEDA()
        if (props.isSelectedAtpBayAndNotVerified) props.clearAtpBookBankNumber()
      }
      props.setTypeDA(typeDA)
    }

    if (getToggles().ENABLE_EDA && changePageOutFromEDAForm) {
      props.clearUIFlagEDAViewFormOnly()
      props.clearEdaStatusOptions()
    }

    if (getToggles().ENABLE_AIUW && changePageToSubmitForm) {
      if (!hasCalledReSaveAiUw.current) {
        hasCalledReSaveAiUw.current = true
        console.log('dispatchReSaveAiUw')

        props.setAiuwSending()
        props.dispatchReSaveAiUw()
      } else {
        console.log('dispatchGetAIUWStatushEvent')
        props.dispatchGetAIUWStatushEvent()
      }
    }

    prevPathName.current = location.pathname
  }, [location.pathname])

  return (
    <div id={`app-form-${props.currentPageId}`} className={className}>
      <InsuredInfoCard />
      {endsWith('/form/signature', match.url) ? <FormValidation /> : null}
      {endsWith('/form/ekyc', match.url) ? <FormValidation /> : null}
      {endsWith('/submit/payment', match.url) ? (
        <FormEngine sections={sections} {...props} />
      ) : (
        <FormEngine sections={sections} {...props} />
      )}
    </div>
  )
})`
  flex: 1 1 auto;
  padding-top: 15px;
  margin: 0 auto;

  &#app-form-KYC {
    .validation-message {
      margin-top: 10px;
    }
  }

  ${`
    &#app-form-submit {
      padding-top: 30px;
    }
  `};
`

const isSubmitPage = isEqual('submit')

const mapStateToProps = (state, props) => {
  const pages = getPages(state)
  const appStatus = getCurrentAppStatus(state)
  const progress = getAppProgress(state)
  const currentPageId = props.match.params.pageId
  const currentPageIndex = findIndex(['id', currentPageId], pages)
  const currentPage = get(currentPageIndex, pages)
  const sections = get('sections', currentPage ? currentPage : [])
  const size = get('size', currentPage ? currentPage : 0)
  const currentApp = getCurrentApp(state)

  let canGotoNextPage = false
  if (currentPage && currentPage?.lastPage) {
    canGotoNextPage = isAllDocumentSigned(state)
  }

  const canSign = currentPage?.isDocumentPage ? isCertifyByAgent(state) : false

  const app = getCurrentApp(state)
  const isSkippedInsuredEkyc = getSkippedInsuredEkyc(app)
  const isSkippedPayerEkyc = getSkippedPayerEkyc(app)
  const insuredDopaResultResponseDataMessage = getInsuredDopaResultResponseDataMessage(app)
  const payerDopaResultResponseDataMessage = getPayerDopaResultResponseDataMessage(app)
  const insuredDopaVerified = getInsuredDopaResult(app)
  const payerDopaVerified = getPayerDopaResult(app)
  const insuredDopaRequestFailed = getInsuredDopaRequestFailed(app)
  const payerDopaRequestFailed = getPayerDopaRequestFailed(app)
  const appId = getCurrentAppId(state)
  const startSaleForm = getStateSaleForm(state)
  const selectedLuckyNumber = getSelectedLuckyNumber(app)
  const isShowLuckyNumber = isLuckyNumber(app)
  const luckyNumberStatus = getLuckyNumberStatus(app)

  const isSelectedEdaBank = isATPBankWasKTB(app) || isATPBankWasBay(app)
  const isSelectedAtpBayAndNotVerified = isATPBankWasBay(app) && !isAccountChecked(app)
  const hasPayer = havePayer(app)
  const insuredJuvenile = isJuvenileEkyc(app)
  const insuredForeigner = isForeigner(app, 'insured')
  const payerForeigner = isForeigner(app, 'payer')
  const selectedF2F = isSelectedF2F(app)
  const selectedRemoteSelling = isSelectedRemoteSelling(app)

  return {
    appStatus,
    canGotoNextPage,
    pages,
    sections,
    progress,
    currentPageId,
    currentPageIndex: Math.max(0, currentPageIndex),
    size,
    canSign,
    isSkippedInsuredEkyc,
    isSkippedPayerEkyc,
    insuredDopaVerified,
    payerDopaVerified,
    insuredDopaRequestFailed,
    payerDopaRequestFailed,
    currentApp,
    appId,
    startSaleForm,
    selectedLuckyNumber,
    isShowLuckyNumber,
    luckyNumberStatus,
    insuredDopaResultResponseDataMessage,
    payerDopaResultResponseDataMessage,
    isSelectedEdaBank,
    isSelectedAtpBayAndNotVerified,
    hasPayer,
    insuredJuvenile,
    insuredForeigner,
    payerForeigner,
    selectedF2F,
    selectedRemoteSelling,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    hideLoading: () => {
      dispatch(hideLoading())
    },
    showDialog: (dialog) => {
      dispatch(showDialog(dialog))
    },
    hideDialog: (dialog) => {
      dispatch(hideDialog(dialog))
    },
    verifyPolicy: (event) => {
      event.preventDefault()
      dispatch(verifyPolicy())
    },
    confirmSubmitted: (event) => {
      event.preventDefault()
      dispatch(comfirmSubmittedPolicy())
    },
    submittedPolicy: (event) => {
      dispatch(submittedPolicy())
    },
    fetchSignature: () => {
      dispatch(fetchSignature())
    },
    dispatchAnalyticsPageViewEvent: bindActionCreators(analyticsPageViewEvent, dispatch),
    dispatchGetAIUWStatushEvent: bindActionCreators(getAIUWStatus, dispatch),
    dispatchReSaveAiUw: bindActionCreators(requestAIUWwithGetStaus, dispatch),
    dispatchSavingAppOnPageNav: bindActionCreators(saveAppData, dispatch),
    openInsuredDopaRequestFailedModal: (insuredOrPayer) => {
      dispatch(setDopaRequestFailedModal(true, 'insured'))
    },
    openPayerDopaRequestFailedModal: (insuredOrPayer) => {
      dispatch(setDopaRequestFailedModal(true, 'payer'))
    },
    dispatchUpdateOptyStageKyc: bindActionCreators(updateOptyStageKyc, dispatch),
    dispatchUppdateOptyStageEApp: bindActionCreators(updateOptyStageEApp, dispatch),
    setTypeDA: (typeDA) => {
      dispatch(setAppValue('ATP.typeDA', typeDA))
    },
    setDefaultBankForEDA: () => {
      dispatch(setAppValue('ATP.bank', { text: 'กรุณาเลือกธนาคาร', monthlyCollect: 1, value: null }))
    },
    clearAtpBookBankNumber: () => {
      dispatch(setAppValue('ATP.bankBookNumber', ''))
      dispatch(setAppValue('ATP.bankBookNumberBay', ''))
    },
    clearUIFlagEDAViewFormOnly: () => {
      dispatch(resetEDAViewFormOnly())
    },
    clearEdaStatusOptions: () => {
      dispatch(unsetEDACheckStatus())
    },
    setConfirmLuckyNumberModal: (val) => {
      dispatch(setConfirmLuckyNumberModal(val))
    },
    setAiuwSending: () => {
      dispatch(setAppValue('AIUW.status', 'requesting'))
    },
  }
}

const mergeProps = (stateProps, actionProps, ownProps) => {
  const pages = stateProps.pages
  const nextPageIndex = stateProps.currentPageIndex + 1
  const currentPage = get(stateProps.currentPageIndex, pages)
  const nextPage = get(nextPageIndex, pages)
  const { currentApp: app } = stateProps
  const shouldDisable = (id, app) => {
    switch (id) {
      case 'video-consent':
        return true
      default:
        return false
    }
  }
  let nextButtonProps = {}
  if (!isNil(nextPage)) {
    if (currentPage.lastPage === true) {
      const buttonProps = {
        type: 'link',
        to: '/e-submission/form/otp',
        text: 'ยืนยันตัวตนลูกค้า',
        disabled: !stateProps.canGotoNextPage,
        onClick: actionProps.verifyPolicy,
      }

      if (getToggles().ENABLE_EKYC_F2F) {
        buttonProps.to = '/e-submission/form/submit'
        buttonProps.text = 'ยืนยัน'
        buttonProps.onClick = actionProps.confirmSubmitted
      }

      nextButtonProps = buttonProps
    } else if (currentPage.isDocumentPage === true && getToggles().ENABLE_TAMLO === true) {
      nextButtonProps = {
        type: 'link',
        to: '/e-submission/form/' + nextPage.id,
        text: nextPage.label,
        disabled: !stateProps.canSign,
      }
    } else if (currentPage.id === 'ekyc') {
      const isOpenInsuredDopaRequestFailedModal =
        (!isNil(stateProps.insuredDopaVerified) && !stateProps.insuredDopaVerified) ||
        stateProps.insuredDopaRequestFailed
      const isOpenPayerDopaRequestFailedModal =
        (!isNil(stateProps.payerDopaVerified) && !stateProps.payerDopaVerified) || stateProps.payerDopaRequestFailed
      const insuredDopaResultResponseDataMessage = stateProps.insuredDopaResultResponseDataMessage || 'สถานะปกติ'
      const payerDopaResultResponseDataMessage = stateProps.payerDopaResultResponseDataMessage || 'สถานะปกติ'

      let checkOpenInsuredDopaRequestFailed = false
      let checkOpenPayerDopaRequestFailed = false

      if (getToggles().ENABLE_PAY_LATER) {
        checkOpenInsuredDopaRequestFailed = isOpenInsuredDopaRequestFailedModal && !stateProps.isSkippedInsuredEkyc
        checkOpenPayerDopaRequestFailed = isOpenPayerDopaRequestFailedModal && !stateProps.isSkippedPayerEkyc
      } else {
        if (stateProps.insuredDopaRequestFailed && !stateProps.isSkippedInsuredEkyc) {
          checkOpenInsuredDopaRequestFailed = true
        } else if (
          !insuredDopaResultResponseDataMessage.includes('สถานะปกติ') &&
          stateProps.insuredDopaRequestFailed &&
          !stateProps.isSkippedPayerEkyc
        ) {
          checkOpenInsuredDopaRequestFailed = true
        }
        if (stateProps.selectedF2F && stateProps.insuredForeigner) {
          checkOpenInsuredDopaRequestFailed = false
        }

        if (stateProps.hasPayer) {
          if (stateProps.payerDopaRequestFailed && !stateProps.isSkippedPayerEkyc) {
            checkOpenPayerDopaRequestFailed = true
          } else if (
            !payerDopaResultResponseDataMessage.includes('สถานะปกติ') &&
            stateProps.payerDopaRequestFailed &&
            !stateProps.isSkippedPayerEkyc
          ) {
            checkOpenPayerDopaRequestFailed = true
          }
          if (stateProps.selectedF2F && stateProps.payerForeigner) {
            checkOpenPayerDopaRequestFailed = false
          }
        }
      }

      if (checkOpenInsuredDopaRequestFailed) {
        nextButtonProps = {
          type: 'link',
          to: '/e-submission/form/ekyc',
          text: 'ยืนยัน eKYC',
          disabled: false,
          onClick: (insuredOrPayer) => {
            actionProps.openInsuredDopaRequestFailedModal(insuredOrPayer)
            actionProps.dispatchUpdateOptyStageKyc()
          },
        }
      } else if (checkOpenPayerDopaRequestFailed) {
        nextButtonProps = {
          type: 'link',
          to: '/e-submission/form/ekyc',
          text: 'ยืนยัน eKYC',
          disabled: false,
          onClick: (insuredOrPayer) => {
            actionProps.openPayerDopaRequestFailedModal(insuredOrPayer)
            actionProps.dispatchUpdateOptyStageKyc()
          },
        }
      } else {
        nextButtonProps = {
          type: 'link',
          to: '/e-submission/form/' + nextPage.id,
          text: 'ยืนยัน eKYC',
          disabled: false,
          onClick: () => {
            actionProps.dispatchUpdateOptyStageKyc()
          },
        }
      }
    } else if (currentPage.id === 'lucky-number' && stateProps.isShowLuckyNumber && !stateProps.luckyNumberStatus) {
      nextButtonProps = {
        type: 'link',
        to: '/e-submission/form/' + currentPage.id,
        text: 'ยืนยัน',
        disabled: !stateProps.selectedLuckyNumber,
        onClick: () => {
          actionProps.setConfirmLuckyNumberModal({ modal: true, from: 'normal-assign' })
        },
      }
    } else {
      nextButtonProps = {
        type: 'link',
        to: '/e-submission/form/' + nextPage.id,
        text: nextPage.label,
        disabled: false,
      }
    }
    if (currentPage.remoteSection) {
      nextButtonProps = {
        type: 'link',
        to: '/e-submission/form/' + nextPage.id,
        text: nextPage.label,
        disabled: shouldDisable(currentPage.id, app),
      }
    }
  }

  const navProps = flow(
    reject(['exclude', true]),
    currentPage.remoteSection ? filter(['remoteSection', true]) : reject(['remoteSection', true]),
    map(({ id, title, label, disabled }) => ({
      id,
      title,
      path: `/e-submission/form/${id}`,
      component: null,
      disabled,
    })),
    when(negate(some(({ path }) => endsWith(path, ownProps.match.url))), () => [])
  )(pages)

  return {
    ...stateProps,
    ...actionProps,
    ...ownProps,
    nextButtonProps,
    navProps,
    fetchSignature: ({ currentPageId }) => {
      if (isSubmitPage(currentPageId)) {
        actionProps.fetchSignature()
      }
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(AppForm)
